import { Box, Container, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { ProfileSidebarNav } from "./ProfileSidebarNav";
import { ProfileTopTabNav } from "./ProfileTopTabNav";
import useGlobalStyles from "styles/globalStyles";

export function ProfileShell({
  children,
  defaultTab = "position",
}: {
  children: (active: string) => React.ReactNode;
  defaultTab?: string;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [active, setActive] = useState(defaultTab);
  const globalStyles = useGlobalStyles();

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {isMobile && <ProfileTopTabNav value={active} onChange={setActive} />}


      <Box sx={{ display: "flex", flexGrow: 1 }} gap={3}>
        {!isMobile && (
          <ProfileSidebarNav value={active} onChange={setActive} />
        )}

        <Box
          sx={{ flexGrow: 1 }}
          mt={{
            xs: 3,
            md: 0,
          }}
        >
          {children(active)}
        </Box>
      </Box>
    </Box>
  );
}
